const connectConfig = {
  backendURL: process.env.REACT_APP_BACKEND_URL,
  backendURLOffice: process.env.REACT_APP_LANDING_BACKEND_URL,
  manningsLandingsSuffixUrl: process.env.REACT_APP_MANNINGS_LANDING_SUFFIX_URL,
  fileFolder: "/uploads",
  s3: "https://pg-promoter-app-s3.s3.ap-southeast-1.amazonaws.com",
  s3Landing: "https://3cb-public-images.s3.ap-southeast-1.amazonaws.com",
};

export default connectConfig;
